import React, { useState, useCallback } from 'react';
import classnames from 'classnames';
import * as styles from './style.module.scss';

import Icon from 'components/UI/Icon';
import Steps from './components/Steps';
import Finish from './components/Finish';
import Image from '@/images/common/get-cirrusoft/img.jpg';
import { CONTACT_PHONE } from '@/mocks/contacts';

import useGravityForm from 'hooks/useGravityForm';

const GetCirrusoft = () => {
  const [isFinish, setIsFinish] = useState(false);
  // TODO: forma
  const submitGravityForm = useGravityForm(1);

  const finishHandler = useCallback(
    (values) => {
      submitGravityForm(values)
        .then(({ confirmation_message }) => {
          console.info(confirmation_message);
        })
        .catch((err) => {
          console.error(err.response);
        });

      setIsFinish(true);
    },
    [submitGravityForm]
  );

  return (
    <div className={styles.quiz}>
      <div className={styles.quiz_img}>
        {/* TODO: заменить gatsby компонентом */}
        <img src={Image} alt="Get Cirrusoft" className={styles.quiz_img_elem} />
        <a
          className={classnames(
            'cr-reg cr-white cr-link',
            styles.quiz_img_phone
          )}
          href={`tel:${CONTACT_PHONE}`}
        >
          <Icon name="phone-call" />
          <span>Or call us</span>
          <span className={'cr-h5'}>{CONTACT_PHONE}</span>
        </a>
      </div>

      <div className={styles.quiz_form}>
        {isFinish ? <Finish /> : <Steps onFinish={finishHandler} />}
      </div>
    </div>
  );
};

export default GetCirrusoft;
